import { render, staticRenderFns } from "./LatePayments.vue?vue&type=template&id=24b3ef2a&"
import script from "./LatePayments.vue?vue&type=script&lang=js&"
export * from "./LatePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports